const initialvalues = {
    addroom: {},
    updateroom:{},
    centername:[],

};

export default function SeatingArrangementReducer(details = initialvalues, action) {
    switch (action.type) {
        case "ADD_ROOM":
            return { ...details, addroom: action.payload };
            case "UPDATE_ROOM":
            return { ...details, updateroom: action.payload };

            case "CENTER_NAME":
                return { ...details, centername: action.payload };

            
        default:
            return details;
    }
}